<template>
  <v-btn :disabled="!datePickerObject" color="red" outlined @click="clicked">
    <i class="fal fa-calendar-day" />
    <span class="ml-2">
      {{ $t('shopBackendBookingComplete.today') }}
    </span>
  </v-btn>
</template>

<script>
export default {
  name: 'DatePickerTodayButton',
  props: {
    datePickerObject: {
      type: Object,
      required: true,
    },
  },

  methods: {
    clicked() {
      const today = new Date().toISOString()
      this.datePickerObject.monthClick(today)
      this.$emit('clicked', today)
    },
  },
}
</script>
